import type { Comment } from './types';

/**
 * The alias a reader's own new anonymous comment will carry, for showing it
 * before the server answers: the number they already have in this thread, or
 * the next free one. The server's number replaces it on the refetch, and
 * agrees, because it counts authors in the same order.
 */
export const anonymousAliasFor = (comments: Comment[], userId: number): number => {
  const all = comments.flatMap((comment) => [comment, ...comment.replies]);

  const own = all.find(
    (comment) => comment.isAnonymous && comment.userId === userId && comment.anonymousAlias
  );

  if (own?.anonymousAlias) {
    return own.anonymousAlias;
  }

  return Math.max(0, ...all.map((comment) => comment.anonymousAlias ?? 0)) + 1;
};
